/** @format */

import React from 'react';
import { useTranslation } from 'react-i18next';
import Date from './Components/Date/Date';
import styles from './Timeline.module.scss';

const Timeline = () => {
  const { t } = useTranslation();
  const timelineDates = [
    {
      text: t('Medical cannabis is legalized'),
      date: '2017',
    },
    {
      text: t(
        'Cannabis legalization is a point of the coalition agreement',
      ),
      date: '2021',
    },
    {
      text: t(
        'First key issue paper is presented',
      ),
      date: '2022',
    },
    {
      text: t('First draft of the cannabis law'),
      date: '2023',
    },
    {
      text: t(
        'February 23: Cannabis law passed in the Bundestag',
      ),
      date: '2024',
    },
    {
      text: t(
        'Start of cultivation at Deutsche Anbaugesellschaft DAG site',
      ),
      date: '2024',
    },
  ];

  return (
    <section id='legalization' className={styles.timeline}>
      <h2 className={styles.timeline__header}>
        {t('Cannabis legalization in Germany')}
      </h2>
      <h2
        className={
          styles.timeline__header_mobile
        }>
        {t('Legalization process')}
      </h2>

      <div className={styles.timeline__inner}>
        {timelineDates.map(
          (timelineDate, index) => {
            const { text, date } = timelineDate;
            return (
              <Date
                text={text}
                date={date}
                key={index}
              />
            );
          },
        )}
      </div>
    </section>
  );
};

export default Timeline;
